import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import "./AddMesureModal.css";

const AddMesureModal = ({ show, onClose, onCreated, showToast }) => {
  const [form, setForm] = useState({
    name: "",
    type: "Organisationnelle",
    reduction: 0,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: name === "reduction" ? parseFloat(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("/api/add_mesure.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();
      if (data.success) {
        showToast("Mesure ajoutée !");
        onCreated?.();
        onClose();
      } else {
        showToast(data.error || "Erreur lors de l'ajout", "danger");
      }
    } catch (err) {
      showToast("Erreur réseau", "danger");
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      centered
      dialogClassName="add-mesure-modal"
    >
      <Form onSubmit={handleSubmit}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="bi bi-shield-check me-2 text-warning" />
              Ajouter une Mesure d’atténuation
            </h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            {/* 🔹 Nom */}
            <div className="mb-3">
              <Form.Label>Nom</Form.Label>
              <Form.Control
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                placeholder="Ex: Pare-feu, MFA, formation..."
              />
            </div>

            {/* 🔹 Type */}
            <div className="mb-3">
              <Form.Label>Type</Form.Label>
              <Form.Select name="type" value={form.type} onChange={handleChange}>
                <option value="Organisationnelle">Organisationnelle</option>
                <option value="Technique">Technique</option>
                <option value="Physique">Physique</option>
                <option value="Humaine">Humaine</option>
              </Form.Select>
            </div>

            {/* 🔹 Réduction */}
            <div className="mb-3">
              <Form.Label>Réduction apportée (%)</Form.Label>
              <Form.Control
                type="number"
                name="reduction"
                min="0"
                max="1"
                step="0.01"
                value={form.reduction}
                onChange={handleChange}
                required
              />
              <small className="text-secondary">
                Exemple : 0.20 pour indiquer une réduction de 20%
              </small>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-profile" onClick={onClose}>
              Annuler
            </button>
            <button type="submit" className="btn-profile btn-success">
              Ajouter
            </button>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default AddMesureModal;
